<template>
	<div v-if="videoContent && videoContent.url" class="c-frontpage-html-video">
		<BaseH2
			v-if="title"
			class="text-h3 text-gray-darker mb-xs/v"
			v-html="title"
		/>
		<div class="c-frontpage-html-video__container">
			<div
				v-if="showPlay"
				class="
					c-frontpage-html-video__overlay
					bg-black bg-opacity-20
					group
				"
				@click="playVideo"
			>
				<BaseButton
					tag="button"
					class="
						px-sm/h
						bg-white
						group-hover:bg-theme-10
						text-theme
						m-xs/v
						>=1024:ml-3xl/v >=1024:mb-lg/h
					"
					v-text="'Afspil'"
				/>
			</div>
			<video
				ref="video"
				:controls="!showPlay"
				class="c-frontpage-html-video__video"
				:src="videoContent.url"
				:width="videoContent.width || '100%'"
				:height="videoContent.height || '100%'"
				muted
				loop
				playsinline
				@pause="onPause"
				@play="onPlay"
			></video>
		</div>
		<p
			class="
				>=1024:w-8/12col
				text-gray-darker text-body
				font-light
				mt-xs/v
			"
		>
			{{ teaser }}
		</p>
	</div>
</template>

<script>
export default {
	name: 'FrontpageVideo',
	props: {
		videoContent: {
			type: Object,
			required: true,
		},
		teaser: {
			type: String,
			default: null,
		},
		title: {
			type: String,
			default: null,
		},
	},
	data() {
		return {
			showPlay: true,
			userPaused: false,
		};
	},

	mounted() {
		this.initObserver();
	},

	beforeDestroy() {
		this.destroyObserver();
	},

	methods: {
		initObserver() {
			this.observer = new IntersectionObserver(
				(entries) => {
					entries.forEach((entry) => {
						if (entry.isIntersecting) {
							if (!this.userPaused) {
								this.playVideo();
							}
						} else {
							this.pauseVideo();
						}
					});
				},
				{ threshold: 0.5 }
			);
			if (this?.$el) {
				this.observer.observe(this.$el);
			}
		},
		destroyObserver() {
			if (this.observer) {
				this.observer.disconnect();
			}
		},
		playVideo() {
			this.$refs.video?.play?.();
			this.showPlay = false;
		},
		pauseVideo() {
			this.$refs.video?.pause?.();
		},
		onPause() {
			// If the video was paused and it's still in view, assume it's a user action
			if (this.observer && this.$el) {
				// We can check if it's currently intersecting, but simpler:
				// If pause is called while we are not programmatically pausing (which usually happens when out of view)
				// Actually, the IntersectionObserver calls pauseVideo() which calls this.$refs.video.pause().
				// To distinguish, we can set a flag during programmatic pause.
			}
			this.userPaused = true;
		},
		onPlay() {
			this.userPaused = false;
		},
	},
};
</script>

<style lang="postcss">
.c-frontpage-html-video__container {
	@apply relative w-screen;
	height: 70vh;
	left: calc(var(--theme-layout-margin, 0px) * -1);

	@screen >=1441 {
		left: calc(
			(100vw - var(--theme-layout-max, 1440px)) / -2 +
				var(--theme-layout-margin, 0px) * -1
		);
	}
}
.c-frontpage-html-video__video {
	height: 100%;
	object-fit: cover;
}

.c-frontpage-html-video__overlay {
	@apply absolute
				cursor-pointer
				w-full
				z-10
				h-full
				flex flex-col
				items-start
				justify-end;
}
</style>
